import { css } from 'linaria';
const regular = 'Roboto';
"f1odlo1m";

function fontFace(name) {
  let exts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['woff2', 'woff'];
  return "\n        @font-face {\n            font-family: ".concat(name, ";\n            src: ").concat(exts.map(ext => {
    return "url(~assets/fonts/".concat(name, ".").concat(ext, ") format('").concat(ext, "')");
  }).join(', '), ";\n            font-weight: normal;\n            font-style: normal;\n        }\n    ");
}

export default {
  regular
};

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/style/fonts.linaria.css");